/*
 * drool-frame-default.js  (additive — safe to remove)
 *
 * Problem it fixes: on DESKTOP the sticky media-gallery re-renders AFTER the
 * theme's frame logic last ran (e.g. when "default to Large" changes the size,
 * the variant morph replaces the gallery DOM). That late re-render drops the
 * default black-frame preview on the visible hero, so the print shows unframed
 * on desktop (mobile was unaffected). The theme's own updateProductPageFrame()
 * fixes it perfectly when called — it just isn't called again after that late
 * re-render, and the gallery node it touched has been swapped out.
 *
 * This watches a STABLE ancestor (the morph swaps the gallery element itself, so
 * observing the gallery directly orphans the observer) and simply RE-INVOKES the
 * theme's existing updateProductPageFrame() once the DOM settles — but ONLY while
 * we're still in the default-frame state. It never runs once the shopper has
 * actively chosen a frame (window.__mrkFrameTouched), so it can't override a real
 * selection.
 */
(function () {
  'use strict';

  function defaultName() { return window.mrk_default_preview_frame || 'black'; }

  // Any on-screen hero frame-wrapper that is NOT currently showing the default
  // frame? (There are several wrappers — mobile hero, desktop hero, thumbs — so
  // we check every large, on-screen one rather than guessing which is "the" hero.)
  function needsFix() {
    var name = defaultName();
    var wraps = document.querySelectorAll('.mrk-featured-product-frame-wrapper');
    for (var i = 0; i < wraps.length; i++) {
      var r = wraps[i].getBoundingClientRect();
      if (r.width > 120 && r.height > 120 && r.top < window.innerHeight && r.bottom > 0) {
        var img = wraps[i].querySelector('.mrk-frame-image-item[color="' + name + '"]');
        if (!img) continue; // this product has no such frame image — nothing we can fix
        var shown = img.classList.contains('mrk-active-gallery-frame') &&
          getComputedStyle(img).display !== 'none';
        if (!shown) return true;
      }
    }
    return false;
  }

  var suppress = false;   // ignore mutations we cause ourselves
  var pending = false;
  var attempts = 0;       // hard cap — a product whose gallery never satisfies the
                          // check must NOT retry forever (updateProductPageFrame →
                          // updateVariants triggers section morphs → mutation → loop)

  function reassert() {
    pending = false;
    if (attempts >= 6) return;                       // give up quietly
    if (window.__mrkFrameTouched) return;           // shopper picked a frame — leave it
    if (!window.show_default_black_variant) return; // not in default-frame mode
    if (!needsFix()) return;                         // already correct — avoid loops
    if (typeof window.updateProductPageFrame !== 'function') return;
    attempts++;
    suppress = true;
    try { window.updateProductPageFrame(); } catch (e) {}
    setTimeout(function () { suppress = false; }, 80);
  }

  function schedule() {
    if (pending) return;
    pending = true;
    setTimeout(reassert, 120); // let the gallery's re-render settle first
  }

  function init() {
    // Observe a STABLE ancestor — the variant morph can replace the
    // <media-gallery> element itself, which would orphan an observer bound to it.
    var root = document.querySelector('.product-information') ||
               document.querySelector('main') || document.body;
    if (root && 'MutationObserver' in window) {
      new MutationObserver(function () { if (!suppress) schedule(); })
        .observe(root, { childList: true, subtree: true });
    }
    // Belt-and-braces nudges across the window where the late desktop re-render
    // and app scripts typically land.
    window.addEventListener('load', schedule);
    document.addEventListener('mrkVariantChanged', function () {
      [0, 250, 700, 1500].forEach(function (d) { setTimeout(schedule, d); });
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
